export default class GetAllCursosNoProgramadosPersonal {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllCursosNoProgramadosPersonal()
      return result
    } catch (error) {
      throw error
    }
  }
}
